var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _g, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkAsSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06689 12.8994L7.82129 13.9007L4.25868 20.0005L3.23614 17.7461L6.06689 12.8994Z",
    fill: "#CE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06689 12.8994L4.3125 11.8981L0.749897 17.9979L3.23614 17.7461L6.06689 12.8994Z",
    fill: "#983535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56982 12.8994L6.81543 13.9007L10.378 20.0005L11.4006 17.7461L8.56982 12.8994Z",
    fill: "#983535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56982 12.8994L10.3242 11.8981L13.8868 17.9979L11.4006 17.7461L8.56982 12.8994Z",
    fill: "#CE4444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54001 0.814994C7.09369 0.344939 7.90631 0.344939 8.45999 0.814994C8.81606 1.11728 9.2998 1.23281 9.75522 1.12917C10.458 0.969243 11.1831 1.34139 11.4516 2.01022C11.6251 2.44208 12.0004 2.76786 12.4508 2.8849C13.1457 3.06547 13.6158 3.73087 13.5394 4.44479C13.49 4.90618 13.6661 5.36479 14.0105 5.67583C14.5451 6.15875 14.6454 6.96428 14.2421 7.56128C13.9824 7.94568 13.9229 8.4315 14.0824 8.86713C14.3293 9.54197 14.0349 10.3001 13.4021 10.6408C12.9931 10.861 12.7088 11.2657 12.645 11.7259C12.5463 12.4378 11.943 12.9713 11.2243 12.9823L11.2036 12.9826C10.7373 12.9897 10.3019 13.2167 10.029 13.5948C9.60573 14.1815 8.81454 14.3724 8.16735 14.0491C7.74909 13.8401 7.25091 13.8401 6.83265 14.0491C6.18546 14.3724 5.39427 14.1815 4.97097 13.5948C4.69814 13.2167 4.26268 12.9897 3.79644 12.9826L3.77568 12.9823C3.057 12.9713 2.45372 12.4378 2.355 11.7259C2.29119 11.2657 2.00693 10.861 1.59788 10.6408C0.965147 10.3001 0.670687 9.54197 0.917643 8.86713C1.07706 8.4315 1.01759 7.94568 0.757923 7.56128C0.354637 6.96428 0.454878 6.15875 0.989512 5.67583C1.33386 5.36479 1.51004 4.90618 1.46064 4.44479C1.38421 3.73087 1.85426 3.06547 2.54918 2.8849C2.99961 2.76786 3.37493 2.44208 3.54835 2.01022C3.81693 1.34139 4.54201 0.969243 5.24478 1.12917C5.7002 1.23281 6.18394 1.11728 6.54001 0.814994Z",
    fill: "url(#paint0_linear_41_5208)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.49437,
    cy: 7.37662,
    rx: 5.28002,
    ry: 5.21939,
    fill: "#705100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_5208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77619,
    cy: 7.93467,
    rx: 5.2923,
    ry: 5.23154,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_5208)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.49397,
    cy: 7.37803,
    rx: 5.2923,
    ry: 5.23154,
    fill: "#E3A504"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.64341,
    cy: 7.63901,
    rx: 4.15708,
    ry: 4.17563,
    fill: "#A36D1D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 7.64376,
    cy: 7.57226,
    rx: 3.88888,
    ry: 3.84423,
    fill: "url(#paint1_linear_41_5208)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.71069,
    cy: 7.57236,
    rx: 2.21264,
    ry: 2.25352,
    fill: "#B5760C"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 7.71086,
    cy: 7.50487,
    rx: 2.07854,
    ry: 2.05468,
    fill: "url(#paint2_linear_41_5208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_5208",
    x1: 7.5,
    y1: 0,
    x2: 7.5,
    y2: 14.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_5208",
    x1: 7.64376,
    y1: 3.72803,
    x2: 7.64376,
    y2: 11.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D79B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_41_5208",
    x1: 7.71086,
    y1: 5.4502,
    x2: 7.71086,
    y2: 9.55955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFDA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D224"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsSignatureIcon);
export default __webpack_public_path__ + "static/media/MarkAsSignatureIcon.b805e4e60e7de807c2bd5744b495731f.svg";
export { ForwardRef as ReactComponent };